import styled from '@emotion/styled'
import AgoraRTC, { DeviceInfo } from 'agora-rtc-sdk-ng'
import { motion } from 'framer-motion'
import { useCallback, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { LuClock3 } from 'react-icons/lu'
import { useNavigate } from 'react-router-dom'
import { useRecoilState, useRecoilValue } from 'recoil'

import logoImg from '@/assets/images/logo2.png'
import exit_btnImg from '@/assets/images/student/exit-btn@2x.png'
import Modal from '@/components/Modal'
import { drawMethodModalState, drawMethodState, paramsState, screenSharingState, useDeviceState } from '@/store/room'
import { ipcInvoke } from '@/utils/electron'
import Rtc, { SettingDevices, UseDeviceName } from '@/utils/rtc'
import { Network, VolumeType } from '@/utils/rtc/agora'

import { roomEvent, rtcClient } from '../..'

export default function Index() {
  const navigate = useNavigate()
  const [exitModalState, setExitModalState] = useState(false)
  const [settingModalState, setSettingModalState] = useState(false)
  const [hideSetting, setHideSetting] = useState(false)
  const [timeStr, setTimeStr] = useState('00:00:00')
  const [settingDevices, setSettingDevices] = useState<SettingDevices[]>([])
  const [useDevice, setUseDevice] = useRecoilState(useDeviceState)
  const [drawMethod, setDrawMethod] = useRecoilState(drawMethodState)
  const [drawMethodModal, setDrawMethodModal] = useRecoilState(drawMethodModalState)
  const [screenSharing, setScreenSharing] = useRecoilState(screenSharingState)
  const params = useRecoilValue(paramsState)
  const toastIdRef = useRef('')
  const volumesRef = useRef<VolumeType[]>([])
  const networkRef = useRef<Network | null>(null)

  useEffect(() => {
    // getDevices()
    // AgoraRTC.onCameraChanged = getDevices
    // AgoraRTC.onMicrophoneChanged = getDevices
    // AgoraRTC.onPlaybackDeviceChanged = getDevices
    roomEvent.on('roomTime', roomTime)
    roomEvent.on('rest-state', closeSetting)
    rtcClient.on('volume-indicator', volumeIndicator)
    rtcClient.on('network-quality', networkQuality)
    return () => {
      roomEvent.removeListener('roomTime', roomTime)
      roomEvent.removeListener('rest-state', closeSetting)
      rtcClient.removeListener('volume-indicator', volumeIndicator)
      rtcClient.removeListener('network-quality', networkQuality)
    }
  }, [])

  // const getDevices = (deviceInfo?: DeviceInfo) => {
  //   if (deviceInfo) {
  //     toastIdRef.current && toast.remove(toastIdRef.current)
  //     toastIdRef.current = toast('检测到设备变动')
  //   }
  //   Rtc.getSettingDevices().then((res) => setSettingDevices(res))
  // }

  const formatTime = (timeNum: number): string => {
    return timeNum < 10 ? `0${timeNum}` : timeNum.toString()
  }

  const roomTime = useCallback((seconds: number) => {
    const hour = Math.floor(seconds / 3600)
    const minute = Math.floor((seconds - hour * 3600) / 60)
    const second = seconds - hour * 3600 - minute * 60
    setTimeStr(seconds > 0 ? `${formatTime(hour)}:${formatTime(minute)}:${formatTime(second)}` : '准备上课')
    if (seconds % 30 === 0) {
      // console.info('音量:', volumesRef.current)
      // console.info('网络:', networkRef.current)
    }
  }, [])

  const closeSetting = useCallback((state: boolean) => {
    if (state) {
      setHideSetting(true)
      setSettingModalState(false)
    } else {
      setHideSetting(false)
    }
  }, [])

  const volumeIndicator = useCallback((volumes: VolumeType[]) => {
    volumesRef.current = volumes
  }, [])

  const networkQuality = useCallback((network: Network) => {
    networkRef.current = network
  }, [])

  const clickExit = () => {
    setExitModalState(true)
  }

  const exit = () => {
    if (screenSharing) {
      ipcInvoke('win', { sendWinName: 'screenRecordMark', method: 'close' })
      ipcInvoke('win', { sendWinName: 'screenRecordControl', method: 'close' })
    }
    window.history.back()
  }

  const deviceChane = (key: UseDeviceName, deviceId: string) => {
    let device = { ...useDevice, [key]: deviceId }
    if (key === 'mainCamera') {
      rtcClient.changeMainCamera({ deviceId: deviceId, publish: true })
      if (deviceId && deviceId === useDevice.viceCamera) {
        rtcClient.changeViceCamera({ deviceId: useDevice.mainCamera, publish: true })
        device = { ...device, viceCamera: useDevice.mainCamera }
      }
    } else if (key === 'viceCamera') {
      rtcClient.changeViceCamera({ deviceId: deviceId, publish: true })
      if (deviceId && deviceId === useDevice.mainCamera) {
        rtcClient.changeMainCamera({ deviceId: useDevice.viceCamera, publish: true })
        device = { ...device, mainCamera: useDevice.viceCamera }
      }
    } else if (key === 'microphone') {
      rtcClient.changeMicrophone({ deviceId: deviceId, publish: true })
    } else {
      console.info('扬声器不支持变更')
    }
    setUseDevice(device)
  }

  return (
    <>
      <div className="h-[7.12vh] w-full flex flex-row items-center bg-[rgba(255,255,255,.2)] justify-start border rounded-[38px] border-solid border-[rgba(255,255,255,0.3)]">
        <img onClick={clickExit} className="anim_btn2 w-[7.12vh] h-[7.12vh]" src={exit_btnImg} alt="" />
        <p className="text-[2vh] text-white flex-1 text-center ml-[-0.8vh]">{timeStr}</p>
      </div>
      <Modal show={exitModalState} title="退出教室" close={false} confirm={exit} cancel={() => setExitModalState(false)}>
        <p className="py-[10px] text-[16px] text-[#333] text-center">确定退出互动教室</p>
      </Modal>
    </>
    // <Container className="fixed min-w-[164.875vh] w-full h-[6vh] bg-[#0a2052]">
    //   <div className="w-[164.875vh] h-full flex items-center justify-between m-auto">
    //     <div className="h-full flex justify-center items-center">
    //       <img
    //         onClick={() => {
    //           ipcInvoke('win', { method: 'minimize' })
    //         }}
    //         className="w-[10vh]"
    //         src={logoImg}
    //       />
    //     </div>
    //     <div className="ml-[3vh] h-full text-[#FFF] text-[1.8vh] flex justify-center items-center">房间号: {params.roomId}</div>
    //     <div className="flex-1 app-drag text-[#FFF] text-[2vh] flex justify-center items-center">
    //       <LuClock3 className="text-[#FFF]" />
    //       &ensp;{timeStr}
    //     </div>
    //     <div className="h-full flex justify-center items-center gap-[1vh]">
    //       {!hideSetting ? (
    //         <div
    //           className="h-[4vh] flex cursor-pointer justify-center items-center rounded-[0.4vh] min-w-[14vh] text-[2vh] text-[#FFF] bg-[#355880] anim_btn2"
    //           onClick={() => setSettingModalState(true)}
    //         >
    //           设备
    //         </div>
    //       ) : null}
    //       <div
    //         className="h-[4vh] flex cursor-pointer justify-center items-center rounded-[0.4vh] min-w-[14vh] text-[2vh] text-[#FFF] bg-[#355880] anim_btn2"
    //         onClick={clickExit}
    //       >
    //         离开教室
    //       </div>
    //     </div>
    //   </div>
    //   <Modal show={exitModalState} title="退出教室" close={false} confirm={exit} cancel={() => setExitModalState(false)}>
    //     <p className="py-[10px] text-[16px] text-[#333] text-center">退出教室后与学员断开连接</p>
    //   </Modal>
    //   <Modal show={settingModalState} title="设置" footer="" confirm={exit} cancel={() => setSettingModalState(false)}>
    //     <div className="w-[400px] mt-[20px] mb-[40px] flex flex-col items-center justify-center gap-[20px]">
    //       <div className="flex items-center p-4 w-full text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400" role="alert">
    //         <svg className="flex-shrink-0 inline w-4 h-4 mr-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
    //           <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
    //         </svg>
    //         <div>如需关闭摄像头或麦克风，设置为「未选择」即可</div>
    //       </div>

    //       {settingDevices.map((v, i) => (
    //         <div key={i} className="w-full h-[40px] pr-[20px] text-[16px] flex items-center justify-center gap-[20px]">
    //           <div className="w-[60px] h-full flex items-end justify-between flex-col">
    //             <div className="flex-1 flex items-center text-right text-[16px]">{v.title}</div>
    //             {v.subTitle ? <div className="text-right text-[12px] text-[#999]">{v.subTitle}</div> : null}
    //           </div>
    //           <div className="flex-1">
    //             <select onChange={(e) => deviceChane(v.key, e.target.value)} value={useDevice[v.key]} className="h-[40px] py-0 px-[10px] text-[14px] w-full leading-[1] bg-select border-[#999]">
    //               <option value="">未选择</option>
    //               {v.devices.map((device, deviceIndex) => (
    //                 <option key={deviceIndex} value={device.deviceId}>
    //                   {device.label}
    //                 </option>
    //               ))}
    //             </select>
    //           </div>
    //         </div>
    //       ))}
    //     </div>
    //   </Modal>
    // </Container>
  )
}

const Container = styled(motion.div)``
